import { createAction } from "./actionUtils";
export const ActionsDisplayString = {
    // Keeping these strings for backward compatibility - these actions are removed already, but the
    // corresponding action records could be existing in older document. So we still need them to support
    // old documents.
    updateDocument: "updated the project",
    setPropertiesToSubject: "set properties for component",
    addNewRoute: "added a route",
    addRoutes: "added routes",
    addBranchPoint: "added a route connection",
    addNewElement: "added an element",
    updateElementsPosition: "moved schematic elements", // rename to "updateElementsSchematicPosition"
    applyAutoLayoutIteration: "applied auto-layout routing",
    // The following ones are generated by creating an action record manually instead of dispatching an action
    // - forkDocument: created in `ForkDocument.tsx`
    // - createDocument: created in `CreateDocument.tsx`
    // - cloneDocument: created in `createDocumentClonedActionRecord`
    forkDocument: "forked the project",
    createDocument: "created the project",
    cloneDocument: "cloned the project",
    createPartTemplate: "created the project from part template",
    undoDocument: "undid a change",
    redoDocument: "redid a change",
    updateElementsLabel: "updated the label of an element",
};
export const createActionRecordAction = (type, prepareAction, displayString) => {
    ActionsDisplayString[type] = displayString;
    return createAction(type, prepareAction);
};
export const createHiddenActionRecordAction = (type, prepareAction, displayString) => {
    ActionsDisplayString[type] = displayString;
    return createAction(type, prepareAction);
};
export const createSystemAction = (type, prepareAction) => {
    return createAction(type, prepareAction);
};
//# sourceMappingURL=actionCreator.js.map